import { TextField } from "@mui/material";

export const TextFieldForCount = (props: any) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/\D/g, "");
    props.onCountChange(props.id, inputValue);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "-" || event.key === ".") {
      event.preventDefault();
    }
  };

  return (
    <>
      <TextField
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        id={`count-${props.id}`}
        variant="outlined"
        type="number"
        sx={{
          width: "150px", // Adjust width as needed
          "& input": {
            padding: "8px", // Adjust padding as needed
            fontSize: "14px", // Adjust font size as needed
          },
          "& .MuiOutlinedInput-root": {
            borderRadius: "4px", // Adjust border radius as needed
          },
          "& input[type='number']::-webkit-inner-spin-button, & input[type='number']::-webkit-outer-spin-button":
            {
              "-webkit-appearance": "none",
              margin: 0,
            },
          "& input[type='number']": {
            "-moz-appearance": "textfield",
          },
        }}
        value={props.value}
        {...props}
      />
    </>
  );
};
